import { AxiosResponse } from 'axios';
import { useQuery } from 'react-query';

import { api } from '../api';

export interface User {
  id: number;
  sub: string;
  cnpj: string;
  email: string;
  phone: string;
  profile: string;
  name: string;
}

interface IGetUsers {
  actualPage: number;
  nPages: number;
  results: User[];
  resultsPerPage: number;
}

interface IParams {
  actualPage: number;
  resultsPerPage: number;
  textParams: string;
}

export async function getUsers(params: IParams): Promise<IGetUsers> {
  const { data } = await api.get<IGetUsers>('users', {
    params: {
      page: params.actualPage,
      resultsPerPage: params.resultsPerPage,
      text: params.textParams,
    },
  });

  return data;
}

export async function deleteUser(userId: number): Promise<AxiosResponse<string, any>> {
  const result = await api.delete<string>(`users/${userId}`);
  return result;
}

export function useUsuarios(params: IParams) {
  return useQuery(
    ['users', params.actualPage, params.resultsPerPage, params.textParams],
    () => getUsers(params),
    {
      staleTime: Infinity,
      retry: 2
    }
  );
}
